import { Autocomplete, Box, TextField } from '@mui/material'
import type { ColumnHeader } from './utils'

type VisibleColumnsPickerProps = {
  columnHeaders: readonly ColumnHeader[]
  visibleColumnHeaders: readonly ColumnHeader[]
  onChange: (visibleColumnIds: ReadonlySet<string>) => void
}

const VisibleColumnsPicker = ({ columnHeaders, visibleColumnHeaders, onChange }: VisibleColumnsPickerProps) => (
  <Box sx={{ p: 1, borderBottom: 1, borderColor: 'divider' }}>
    <Autocomplete
      multiple
      size="small"
      options={[...columnHeaders]}
      value={[...visibleColumnHeaders]}
      onChange={(_, newValue) => onChange(new Set(newValue.map((c) => c.id)))}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) =>
        option.label.secondary ? `${option.label.primary} (${option.label.secondary})` : option.label.primary
      }
      renderInput={(params) => <TextField {...params} label="Visible columns" placeholder="Add column" />}
    />
  </Box>
)

export default VisibleColumnsPicker
